import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IApiError, IPeriod, ITmpEmployee, ITmpProject, ITmpProjectManager } from '../model/interfaces'
import { modalActions } from './modal.slice'

interface ITmpState {
  period: IPeriod | null
  selectedPeriods: IPeriod[]
  doRemovePeriods: IPeriod[]
  employee: ITmpEmployee
  project: ITmpProject
  projectManager: ITmpProjectManager
  apiError: IApiError
}

const initialState: ITmpState = {
  period: null,
  selectedPeriods: [],
  doRemovePeriods: [],
  employee: {
    _id: '',
    firstName: '',
    lastName: '',
    birthDay: null,
    comment: '',
    config: {},
    isActive: true,
    validate: {
      isValid: false,
      showError: false,
      message: []
    }
  },
  project: {
    _id: '',
    title: '',
    code: '',
    from: null,
    to: null,
    config: {},
    isActive: true,
    validate: {
      isValid: false,
      showError: false,
      message: []
    }
  },
  projectManager: {
    _id: '',
    firstName: '',
    lastName: '',
    birthDay: null,
    comment: '',
    config: {},
    isActive: true,
    validate: {
      isValid: false,
      showError: false,
      message: []
    }
  },
  apiError: {
    isError: false,
    message: ''
  }
}

export const tmpSlice = createSlice({
  name: 'tmp',
  initialState,
  reducers: {
    setTmpPeriod(state, action: PayloadAction<IPeriod | null>) {
      state.period = action.payload
    },
    setSelectedTmpPeriods(state, action: PayloadAction<IPeriod[]>) {
      state.selectedPeriods = action.payload
    },
    setDoRemoveTmpPeriods(state, action: PayloadAction<IPeriod[]>) {
      state.doRemovePeriods = action.payload
    },
    setTmpEmployee(state, { payload }: PayloadAction<ITmpEmployee>) {
      state.employee = payload
    },
    setTmpProjectManager(state, { payload }: PayloadAction<ITmpProjectManager>) {
      state.projectManager = payload
    },
    setTmpProject(state, { payload }: PayloadAction<ITmpProject>) {
      state.project = payload
    },
    setError(state, { payload }: PayloadAction<{ isError: boolean; message: string }>) {
      state.apiError = payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(modalActions.onShowModal.match, (state, { payload }) => {
      if (!payload) {
        state.period = initialState.period
        state.selectedPeriods = initialState.selectedPeriods
        state.doRemovePeriods = initialState.doRemovePeriods
        state.employee = initialState.employee
        state.project = initialState.project
        state.projectManager = initialState.projectManager
        state.apiError = initialState.apiError
      }
    })
  }
})

export const tmpActions = tmpSlice.actions
export const tmpReducer = tmpSlice.reducer
